var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-container"},[(_setup.props.title)?_c('div',{staticClass:"title"},[_c('div',[_vm._v(_vm._s(_setup.props.title))])]):_vm._e(),_vm._v(" "),_vm._t("custom-header"),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }